import d from "./index.es473.js";
function p(t, o) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r) return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = u(t)) || o) {
    r && (t = r);
    var n = 0;
    return function() {
      return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function u(t, o) {
  if (t) {
    if (typeof t == "string") return l(t, o);
    var r = {}.toString.call(t).slice(8, -1);
    return r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set" ? Array.from(t) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? l(t, o) : void 0;
  }
}
function l(t, o) {
  (o == null || o > t.length) && (o = t.length);
  for (var r = 0, n = Array(o); r < o; r++) n[r] = t[r];
  return n;
}
function y(t) {
  for (var o = t.images, r = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><xdr:wsDr xmlns:xdr="http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing" xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">', n = 0, f = function() {
    var e = i.value, c = n + 1, a = function(x) {
      return v(x, e.dpi);
    };
    r += "<xdr:oneCellAnchor>", r += "<xdr:from>", r += "<xdr:col>".concat(e.anchor.column - 1, "</xdr:col>"), r += "<xdr:colOff>".concat(typeof e.offsetX == "number" ? a(e.offsetX) : 0, "</xdr:colOff>"), r += "<xdr:row>".concat(e.anchor.row - 1, "</xdr:row>"), r += "<xdr:rowOff>".concat(typeof e.offsetY == "number" ? a(e.offsetY) : 0, "</xdr:rowOff>"), r += "</xdr:from>", r += '<xdr:ext cx="'.concat(a(e.width), '" cy="').concat(a(e.height), '"/>'), r += "<xdr:pic>", r += "<xdr:nvPicPr>", r += '<xdr:cNvPr id="'.concat(c, '" name="').concat(e.title ? d(e.title) : "Picture " + c, '" descr="').concat(e.description ? d(e.description) : "", '"/>'), r += "<xdr:cNvPicPr>", r += '<a:picLocks noChangeAspect="1"/>', r += "</xdr:cNvPicPr>", r += "</xdr:nvPicPr>", r += "<xdr:blipFill>", r += '<a:blip xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" r:embed="rId'.concat(c, '" cstate="print"/>'), r += "<a:stretch>", r += "<a:fillRect/>", r += "</a:stretch>", r += "</xdr:blipFill>", r += "<xdr:spPr>", r += '<a:prstGeom prst="rect">', r += "<a:avLst/>", r += "</a:prstGeom>", r += "</xdr:spPr>", r += "</xdr:pic>", r += "<xdr:clientData/>", r += "</xdr:oneCellAnchor>", n++;
  }, m = p(o), i; !(i = m()).done; )
    f();
  return r += "</xdr:wsDr>", r;
}
var s = 96, h = 96;
function v(t, o) {
  var r = s;
  return Math.round(t * 9525 * (s / r) * (h / o));
}
export {
  y as default
};
//# sourceMappingURL=index.es429.js.map
